"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8714],{

/***/ 348704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MiddleBody5; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CategorySlider/CategorySlider.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  margin-bottom: 2rem;\n  position: sticky;\n  left: 0;\n  width: 100%;\n  background: #ffffff;\n  z-index: 5;\n  box-shadow: 0px 10px 6px -8px #00000029;\n\n  @media screen and (min-width: 767px) {\n    top: 58px;\n    max-height: 100px;\n  }\n\n  @media screen and (max-width: 766px) {\n    top: 47px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin: 1rem 1rem 0.6rem;\n  padding: 0.7rem 0 !important;\n  flex: 1;\n  flex-flow: row nowrap;\n  overflow-y: auto;\n  scroll-behavior: scroll;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n\n  & > ul {\n    display: flex;\n    list-style-type: none;\n    padding-bottom: 10px;\n  }\n\n  & a {\n    text-decoration: none;\n  }\n\n  &::-webkit-scrollbar {\n    height: 1px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #cbcbcb;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    height: 3px;\n    background: #000000;\n  }\n\n  &::-webkit-scrollbar-button {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  margin: 0 10px;\n  background: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  font-weight: 500;\n  cursor: pointer;\n  max-width: 320px;\n  width: fit-content;\n  word-break: keep-all;\n  white-space: nowrap;\n\n  & > .item-seperator {\n    height: 100%;\n    border-right: 1px dashed #cbcbcb;\n    position: relative;\n  }\n\n  & > p {\n    margin: 0;\n    width: 100%;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n\n  &:first-child {\n    margin-left: 0;\n  }\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 10px 20px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 12px;\n    padding: 5px 7px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var CategorySlider = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CategorySlider",
    componentId: "sc-12a69d60-0"
})(_templateObject());
var CategoryInner = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    displayName: "CategoryInner",
    componentId: "sc-12a69d60-1"
})(_templateObject1());
var CategoryItem = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "CategoryItem",
    componentId: "sc-12a69d60-2"
})(_templateObject2(), function(props) {
    return props.selected ? props.backgroundColor || "#6E27FF" : "transparent";
}, function(props) {
    return props.selected ? props.fontColor || "#ffffff" : "#A0A0A0";
}, function(props) {
    return props.roundness || "0px";
});

// EXTERNAL MODULE: ./src/utils/emoticonsStatus.js
var emoticonsStatus = __webpack_require__(218626);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
;// CONCATENATED MODULE: ./src/components/DesignSystem/CategorySlider/index.js







var CategorySliderComp = function(props) {
    var ref;
    var _showCardButton = props.showCardButton, showCardButton = _showCardButton === void 0 ? false : _showCardButton;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.catalogReducer;
    }), categories = ref1.categories, productTags = ref1.productTags;
    var theme = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }).theme;
    var ref2 = (0,react.useState)(""), bgColor = ref2[0], setBgColor = ref2[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var ref;
        if (theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color) {
            var ref1;
            setBgColor(theme === null || theme === void 0 ? void 0 : (ref1 = theme.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color);
        }
    }, [
        theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) && (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cid) !== -1) {
            setTimeout(function() {
                var ref;
                (ref = document.getElementById("category-".concat(router.query.cid))) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    inline: "nearest"
                });
            }, 300);
        }
    }, [
        router.query.cid
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySlider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryInner, {
            children: (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories)).map(function(item, index) {
                return item.hasOwnProperty("is_active") && item.is_active === 0 || /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryItem, {
                    id: "category-".concat(item.id),
                    backgroundColor: bgColor,
                    fontColor: "#ffffff",
                    showButton: showCardButton,
                    selected: index === props.activeIndex,
                    onClick: function() {
                        return props.onItemSelection(item.id);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: (item.hasOwnProperty("is_custom_tag") ? (0,emoticonsStatus/* removeEmoticons */._)(item.name) : item.name) || "Available Items"
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var DesignSystem_CategorySlider = (CategorySliderComp);

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(840237);
// EXTERNAL MODULE: ./src/utils/conditionalForMiddlebodyRender.js
var conditionalForMiddlebodyRender = __webpack_require__(156385);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/DesktopDsAds.js + 1 modules
var DesktopDsAds = __webpack_require__(916490);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/index.js + 6 modules
var components = __webpack_require__(77198);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(780058);
// EXTERNAL MODULE: ./src/components/SortingAndFiltersTab/SortingAndFiltersTab.js + 2 modules
var SortingAndFiltersTab = __webpack_require__(333636);
// EXTERNAL MODULE: ./src/hooks/useTriggerInitialFilterOptions.js
var useTriggerInitialFilterOptions = __webpack_require__(542249);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(995421);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs
var motion = __webpack_require__(307312);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js + 4 modules
var FilterDrawer = __webpack_require__(391612);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/FilterDrawerMiddleBody5.js








function FilterDrawerMiddleBody5(props) {
    var dispatch = (0,es/* useDispatch */.I0)();
    var showFilterDrawer = props.showFilterDrawer, handleShowFilterDrawer = props.handleShowFilterDrawer;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            headerHeight: state.commonReducer.headerHeight,
            headerRef: state.commonReducer.headerRef
        };
    }), headerHeight = ref.headerHeight, headerRef = ref.headerRef;
    (0,react.useEffect)(function() {
        dispatch((0,common/* hideFiltersCategoryAndCollection */.Zw)(true));
        return function() {
            dispatch((0,common/* hideFiltersCategoryAndCollection */.Zw)(false));
        };
    }, []);
    (0,react.useEffect)(function() {
        if (checkClientDeviceType/* IS_MOBILE */.q$ && showFilterDrawer) {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        }
        return function() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        };
    }, [
        showFilterDrawer
    ]);
    (0,react.useEffect)(function() {
        if (checkClientDeviceType/* IS_MOBILE */.q$ && headerRef.current) {
            showFilterDrawer ? headerRef.current.style.display = "none" : headerRef.current.style.display = "";
        }
    }, [
        showFilterDrawer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            initial: {
                opacity: 0,
                x: checkClientDeviceType/* IS_MOBILE */.q$ ? 0 : -300,
                zIndex: -1
            },
            transition: checkClientDeviceType/* IS_MOBILE */.q$ ? {
                duration: 0.5
            } : {
                duration: 0.5
            },
            animate: {
                opacity: 1,
                x: 0,
                zIndex: checkClientDeviceType/* IS_MOBILE */.q$ ? 12 : 0
            },
            exit: {
                opacity: 0,
                x: checkClientDeviceType/* IS_MOBILE */.q$ ? 0 : -300,
                zIndex: -1
            },
            style: {
                height: "100vh",
                display: "flex",
                top: checkClientDeviceType/* IS_MOBILE */.q$ ? 0 : headerHeight,
                position: checkClientDeviceType/* IS_MOBILE */.q$ ? "fixed" : "sticky",
                background: "white"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hybrid_styles/* FilterDrawerWrapper */.Y$, {
                showFilterDrawer: showFilterDrawer,
                ref: props.filterDrawerWrapperRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                        handleShowFilterDrawer: handleShowFilterDrawer,
                        hideCollectionFilter: props.hideCollectionFilter,
                        hideCategoryFilter: props.hideCategoryFilter,
                        hideTags: props.hideTags
                    }),
                    checkClientDeviceType/* IS_MOBILE */.q$ && props.showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hybrid_styles/* FilterDrawerMobileCtaContainer */.UT, {
                        onClick: handleShowFilterDrawer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* FilterDrawerMobileCta */.Bv, {
                                children: "Close"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* FilterDrawerMobileCtaApply */.ef, {
                                children: "Apply"
                            })
                        ]
                    })
                ]
            })
        }, "filterDrawer")
    });
}
/* harmony default export */ var components_FilterDrawerMiddleBody5 = (FilterDrawerMiddleBody5);

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/utils/useGetAnimationTranslation.js
var useGetAnimationTranslation = __webpack_require__(964604);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(155772);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/getFilteredOptionProducts.js
var getFilteredOptionProducts = __webpack_require__(936051);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(179220);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(368464);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/components/SortAndFilteredItems/SortAndFilteredItems.tsx












// import LoaderIcon from '@/components/Common/LoaderIcon';





var TYPE_TAG = 3;
function SortAndFilteredItems() {
    var plpInitFilterCall = function plpInitFilterCall() {
        var ref;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) {
            var selectedCategory = categories.find(function(categoryItem) {
                var ref;
                return (categoryItem === null || categoryItem === void 0 ? void 0 : categoryItem.id) == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedCategory) {
                var categoryFilterObject = {};
                var categorySubFilter = [];
                var subFilter = {};
                subFilter["id"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id;
                subFilter["name"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name;
                categorySubFilter.push(subFilter);
                categoryFilterObject["sub_filters"] = categorySubFilter;
                categoryFilterObject["name"] = "Categories";
                categoryFilterObject["type"] = 2;
                dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                    categoryFilterObject
                ]));
                setInitialFilter([
                    categoryFilterObject
                ]);
                plpFilterCall(categoryFilterObject, constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
            var selectedTag = productTags.find(function(tagItem) {
                var ref;
                return (tagItem === null || tagItem === void 0 ? void 0 : tagItem.id) == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedTag) {
                var tagFilterObject = {};
                var tagSubFilter = [];
                var subFilter1 = {};
                subFilter1["id"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.id;
                subFilter1["name"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.name;
                tagSubFilter.push(subFilter1);
                tagFilterObject["sub_filters"] = tagSubFilter;
                tagFilterObject["name"] = "Tags";
                tagFilterObject["type"] = 3;
                dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                    tagFilterObject
                ]));
                setInitialFilter([
                    tagFilterObject
                ]);
                plpFilterCall(tagFilterObject, constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
        }
    };
    var getSelectedFilters = function getSelectedFilters() {
        var ref, ref1, ref2, ref3;
        /** add previous filteroption of collection and category and PLP page */ var tempFiltersArray = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) !== undefined || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) !== undefined ? (0,_to_consumable_array/* default */.Z)(initialFilter) : [];
        if ((initialFilter === null || initialFilter === void 0 ? void 0 : (ref2 = initialFilter[0]) === null || ref2 === void 0 ? void 0 : ref2.type) === TYPE_TAG && (router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.cid)) {
            tempFiltersArray = [];
        }
        !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && filteredOptions.forEach(function(filterItem) {
            var ref;
            var tempFilterObject = {};
            var tempSubFilterArray = [];
            !!((ref = filterItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterItem.sub_filters.forEach(function(subFilterItem) {
                var tempSubFilters = {};
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    tempSubFilters["id"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.id;
                    tempSubFilters["name"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.name;
                    tempSubFilters["colour_code"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.colour_code;
                    tempSubFilterArray.push(tempSubFilters);
                }
            });
            if (tempSubFilterArray === null || tempSubFilterArray === void 0 ? void 0 : tempSubFilterArray.length) {
                tempFilterObject["name"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.name;
                tempFilterObject["type"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.type;
                tempFilterObject["sub_filters"] = tempSubFilterArray;
                tempFiltersArray.push(tempFilterObject);
            }
        });
        return tempFiltersArray;
    };
    var returnFilterItemsData = function returnFilterItemsData() {
        return filteredItems;
    };
    var changeinitialPlpCallToFalse = function changeinitialPlpCallToFalse(status, isNextPage) {
        if (status) {
            initialPlpCall.current = false;
            dispatch((0,catalog/* setMB5SortAndFilterConfig */.e)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                isNext: isNextPage
            })));
        }
    };
    var plpFilterCall = function plpFilterCall(filterObject, sortType) {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: [
                filterObject
            ]
        };
        initialPlpCall.current = true;
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, changeinitialPlpCallToFalse));
        dispatch((0,catalog/* filtersCounter */.Ds)(constants/* FILTER_COUNTER_OPTIONS.INC */.zO.INC));
    };
    var ref, ref1, ref2;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref3.widgetContextState.globalStyle;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(false), isFullItemsLoaded = ref4[0], setIsFullItemsLoaded = ref4[1];
    var ref5 = (0,react.useState)([]), initialFilter = ref5[0], setInitialFilter = ref5[1];
    var loader = (0,react.useRef)(false);
    var initialPlpCall = (0,react.useRef)(false);
    var state = (0,es/* useSelector */.v9)(function(state) {
        var catalogData = state.catalogReducer;
        return {
            state: catalogData.mb5PaginationData.sortAndFilterConfig
        };
    }).state;
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredItems: state.catalogReducer.filteredItems,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filteredOptions: state.catalogReducer.filteredOptions
        };
    }), filteredItems = ref6.filteredItems, filterAppliedCounter = ref6.filterAppliedCounter, sortType = ref6.sortType, filteredOptions = ref6.filteredOptions;
    var ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1;
        return {
            storeData: state.storeReducer.store,
            categories: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.categories,
            productTags: (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.productTags
        };
    }), storeData = ref7.storeData, categories = ref7.categories, productTags = ref7.productTags;
    (0,react.useEffect)(function() {
        var ref, ref1;
        var pNo = state.pageNo;
        /** if it is plp page plpinitfiltercall will call api with page no 1 */ if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) !== undefined && !sortType && filterAppliedCounter <= 1 && !(parseInt(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cid) === -1)) {
            pNo = [
                0,
                1
            ];
        } else {
            pNo = [
                0
            ];
        }
        loader.current = false;
        dispatch((0,catalog/* resetFilterItems */.V$)());
        dispatch((0,catalog/* setMB5SortAndFilterConfig */.e)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            pageNo: pNo,
            isNext: true
        })));
    }, [
        filterAppliedCounter,
        sortType
    ]);
    (0,react.useEffect)(function() {
        initialPlpCall.current = false;
        plpInitFilterCall();
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid,
        categories,
        productTags
    ]);
    function loadMoreItems() {
        return _loadMoreItems.apply(this, arguments);
    }
    function _loadMoreItems() {
        _loadMoreItems = (0,_async_to_generator/* default */.Z)(function() {
            var pNo, isNextPage, currentPageNo, ref, status, is_next_page;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pNo = state.pageNo;
                        isNextPage = state.isNext;
                        currentPageNo = pNo[(pNo === null || pNo === void 0 ? void 0 : pNo.length) - 1] + 1;
                        if (!(!loader.current && isNextPage && !initialPlpCall.current)) return [
                            3,
                            2
                        ];
                        loader.current = true;
                        return [
                            4,
                            (0,getFilteredOptionProducts/* getFilteredOptionsProducts */.H)(getSelectedFilters(), currentPageNo)
                        ];
                    case 1:
                        ref = _state.sent(), status = ref.status, is_next_page = ref.is_next_page;
                        if (status) {
                            pNo.push(currentPageNo);
                            isNextPage = is_next_page;
                            if (!is_next_page) {
                                setIsFullItemsLoaded(true);
                            }
                        }
                        loader.current = false;
                        _state.label = 2;
                    case 2:
                        dispatch((0,catalog/* setMB5SortAndFilterConfig */.e)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            pageNo: pNo,
                            isNext: isNextPage
                        })));
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMoreItems.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "SortAndFilteredItemsMid5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                isLoaderVisible: false,
                isNext: true,
                onScrollEnd: function() {
                    return loadMoreItems();
                },
                // add LoaderComponent for loading sections
                renderInsideFragment: true,
                renderList: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                        productList: returnFilterItemsData(),
                        oldCardConfigs: {
                            showButton: true,
                            noTagsReadState: "fromLength"
                        }
                    });
                }
            }),
            loader.current && state.isNext && !isFullItemsLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt4 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
                })
            })
        ]
    });
}
/* harmony default export */ var SortAndFilteredItems_SortAndFilteredItems = (SortAndFilteredItems);

// EXTERNAL MODULE: ./src/utils/Widget2.0BuilderUtils.tsx
var Widget2_0BuilderUtils = __webpack_require__(146788);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/index.js













// import useIsComponentMounted from '@/utils/useIsComponentMounted';











var HybridFiltered = function(props) {
    var handleShowFilterDrawer = function handleShowFilterDrawer(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowFilterDrawer(!showFilterDrawer);
    };
    var returnMiddleBodyWidget = function returnMiddleBodyWidget() {
        return shouldRenderSortAndFilter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SortAndFilteredItems_SortAndFilteredItems, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components.SelectedCategoryItems, (0,_object_spread/* default */.Z)({
            activeCategoryIndex: activeCategoryIndex
        }, commonProps));
    };
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,react.useState)(null), categorySelected = ref4[0], setCategorySelected = ref4[1];
    var ref5 = (0,react.useState)(0), activeCategoryIndex = ref5[0], setActiveCategoryIndex = ref5[1];
    var ref6 = (0,react.useState)(null), showFilterDrawer = ref6[0], setShowFilterDrawer = ref6[1];
    var filterDrawerWrapperRef = (0,react.useRef)();
    var ref7 = (0,useGetAnimationTranslation/* default */.Z)(showFilterDrawer), translationDistanceForAnimation = ref7.translationDistanceForAnimation, middleBodyContainerRef = ref7.middleBodyContainerRef;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,common/* getHeroBannerHeightCalculation */.A4)());
    }, []);
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref8[0];
    var ref9 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store,
            catalogData: state.catalogReducer,
            commonData: state.commonReducer,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType
        };
    }), _catalogData = ref9.catalogData, categories = _catalogData.categories, productTags = _catalogData.productTags, _commonData = ref9.commonData, heroBannerHeightCalculated = _commonData.heightCalculation.heroBannerHeightCalculated, filterAppliedCounter = ref9.filterAppliedCounter, sortType = ref9.sortType;
    var ref10 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    }), store_info = ref10.store_info, theme = ref10.theme;
    var ContainerHOC = (0,Widget2_0BuilderUtils/* useProductListParentForBuilderHOC */.i)(Hybrid_styles/* Container */.W2);
    var categoryListRef = (0,react.useRef)(null);
    var iteratableCategories = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories));
    }, [
        productTags === null || productTags === void 0 ? void 0 : productTags.length,
        categories === null || categories === void 0 ? void 0 : categories.length
    ]);
    var shouldRenderSortAndFilter = (sortType || filterAppliedCounter || (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid)) && (props === null || props === void 0 ? void 0 : props.sortAndFiltersEnabled);
    var commonProps = {
        onItemClick: onItemClick,
        showATCBtn: props.showATCBtn,
        iteratableCategories: iteratableCategories,
        categorySelected: categorySelected
    };
    (0,useTriggerInitialFilterOptions/* default */.Z)((router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cid) === undefined);
    (0,react.useEffect)(function() {
        var filteredIndexFunc = function() {
            var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            if (id) return (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories)).findIndex(function(el) {
                return el.id === Number(id);
            });
        };
        if (iteratableCategories.length > 0) {
            var ref;
            if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) >= 0) {
                var ref1, ref2;
                setCategorySelected(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cid);
                setActiveCategoryIndex(filteredIndexFunc(router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.cid));
            } else {
                var ref3;
                setCategorySelected(iteratableCategories === null || iteratableCategories === void 0 ? void 0 : (ref3 = iteratableCategories[0]) === null || ref3 === void 0 ? void 0 : ref3.id);
                setActiveCategoryIndex(0);
            }
        }
    }, [
        router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.cid,
        iteratableCategories
    ]);
    var onSelectedCategoryChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var util, getRoute, PATH, route;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        window.scrollTo({
                            top: 0
                        });
                        categoryListRef.current.scrollTo({
                            top: 0
                        });
                        // categoryListRef.current.scrollIntoView({ behavior: 'instant' });
                        if (id == categorySelected) return [
                            2
                        ];
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 540190))
                        ];
                    case 1:
                        util = _state.sent();
                        getRoute = util.getRoute, PATH = util.PATH;
                        route = getRoute("".concat(props.shopPageBoolean ? PATH.SHOP : PATH.PRODUCT, "?cid=").concat(id), store_info === null || store_info === void 0 ? void 0 : store_info.domain);
                        setTimeout(function() {
                            return router.push(route, undefined, {
                                shallow: true
                            });
                        }, 900);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSelectedCategoryChange(id) {
            return _ref.apply(this, arguments);
        };
    }();
    return (0,conditionalForMiddlebodyRender/* conditionalForMiddlebodyRender */.Y)(heroBannerHeightCalculated, (theme === null || theme === void 0 ? void 0 : theme.theme_id) || (theme === null || theme === void 0 ? void 0 : theme.theme_id) === 0, router === null || router === void 0 ? void 0 : (ref3 = router.route) === null || ref3 === void 0 ? void 0 : ref3.includes("shop")) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row ".concat(showFilterDrawer ? "" : "justify-center"),
        children: [
            props.sortAndFiltersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterDrawerMiddleBody5, {
                showFilterDrawer: showFilterDrawer,
                handleShowFilterDrawer: handleShowFilterDrawer,
                filterDrawerWrapperRef: filterDrawerWrapperRef,
                hideCollectionFilter: true,
                hideCategoryFilter: true,
                hideTags: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hybrid_styles/* AdWidgetContainer */.Ne, {
                trasnlationDist: translationDistanceForAnimation.current,
                ref: middleBodyContainerRef,
                showFilterDrawer: showFilterDrawer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDsAds/* default */.Z, {
                        mr: "mr20px",
                        pt: "pt70px",
                        mb: "mb180px",
                        ml: "ml20px",
                        id: "DesktopDsAds-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerHOC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* Heading */.X6, {
                                children: "Categories"
                            }),
                            props.sortAndFiltersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortingAndFiltersTab/* default */.Z, {
                                middleBodyRef: middleBodyContainerRef,
                                showFilterDrawer: showFilterDrawer,
                                filterDrawerWrapperRef: filterDrawerWrapperRef,
                                handleShowFilterDrawer: handleShowFilterDrawer
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignSystem_CategorySlider, {
                                categories: categories,
                                activeIndex: activeCategoryIndex,
                                onItemSelection: onSelectedCategoryChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: categoryListRef
                            }),
                            returnMiddleBodyWidget()
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDsAds/* default */.Z, {
                        mr: "mr20px",
                        pt: "pt70px",
                        mb: "mb180px",
                        ml: "ml20px",
                        id: "DesktopDsAds-2"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MiddleBody5 = (HybridFiltered);


/***/ })

}]);